<template>
  <div class="overlay">
    <div class="overlay-text">
      <div class="overlay-icon">
        <el-icon class="loading-icon" :size="25">
          <Loading />
        </el-icon>
      </div>
      <div class="overlay-title">正在加载数据</div>
    </div>
  </div>
</template>
<style scoped>
/* 全屏遮罩层的样式 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%; /* 宽度和高度都设置为100%，覆盖整个视口 */
  height: 100%;
  background-color: rgba(37, 37, 37, 0.5);
  z-index: 999; /* 确保在其他元素之上 */
  display: flex; /* 使用 flex 布局使内容垂直和水平居中 */
  justify-content: center;
  align-items: center;
}

/* 可选的文本样式 */
.overlay-text {
  width: 100%;
  color: #3da1d3;
  display: flex;
  width: 160px;
  margin: 0 auto;
}

.overlay-icon {
  width: 20px;
  color: #3da1d3;
  text-align: right;
}

.overlay-title {
  flex: 1;
  font-size: 18px;
  font-weight: bold;
  padding-left: 10px;
}

.loading-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<script setup>
</script>